// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"9ff1b6da","355":"d9e59f6c","471":"1db0891b","831":"0e26a51e"}[chunkId] + ".chunk.css";
};